// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LckT","colBig":"styles_colBig__3pKKe","colSmall":"styles_colSmall__1SNJH","shopifyNameWrapper":"styles_shopifyNameWrapper__Nw-Uz"};